<template>
  <v-container fluid id="fcreate">
    <breadcrumbs/>
    <h1 class="mb-2">
      Новая СЕО запись
    </h1>
    <v-row>
      <v-form v-model="valid" ref="form" @submit.prevent="submit">
        <v-container fluid>
          <v-row>
            <!-- Название -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.name"
                label="Название"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- URL -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.url"
                label="Адрес страницы без домена"
                outlined
                required
                :rules="rules.required"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Регион -->
            <v-col cols="12" md="7">
              <v-autocomplete
                v-model="data.regionId"
                :items="regions"
                item-text="name"
                item-value="id"
                label="Регион"
                clearable
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- metaTitle -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.metaTitle"
                label="Meta title"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- metaDescription -->
            <v-col cols="12" md="7">
              <v-textarea
                v-model="data.metaDescription"
                rows="4"
                label="Meta description"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- pageTitle -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.pageTitle"
                label="Заголовок страницы (h1)"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Текст -->
            <v-col cols="12" md="7">
              <v-textarea
                v-model="data.text"
                rows="10"
                label="Текст"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Статус -->
            <v-col cols="12" md="7">
              <v-checkbox
                v-model="data.status"
                label="Активно"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>

            <!-- Submit -->
            <v-col cols="12" md="7">
              <v-row>
                <v-col>
                  <v-btn
                    block
                    class="mb-2"
                    large
                    color="success"
                    :loading="loading"
                    :disabled="loading"
                    type="submit"
                  >
                    Создать
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn
                    block
                    large
                    color="primary"
                    :loading="loading"
                    :disabled="loading"
                    @click.prevent="$router.back()"
                  >
                    Отмена
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-row>
    <v-snackbar v-model="snackbar">
      Исправьте ошибки и повторите попытку
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import rules from '@/mixins/rules'
  import snackbarMessage from '@/mixins/snackbar-message'
  import { mapGetters } from 'vuex'

  export default {
    mixins: [rules, snackbarMessage],
    data () {
      return {
        data: {
          name: null,
          metaDescription: null,
          metaTitle: null,
          pageTitle: null,
          regionId: null,
          status: true,
          text: null,
          url: null,
        },
        valid: false,
        loading: false,
        snackbar: false,
      }
    },
    computed: {
      ...mapGetters({
        regions: 'regions/getRegions',
      }),
    },
    async created () {
      await this.$store.dispatch('regions/fetchRegions')
    },
    methods: {
      async submit () {
        const validate = await this.$refs.form.validate()

        if (validate) {
          this.loading = true

          try {
            const data = this.data

            const res = await this.$store.dispatch('seo/createPageMeta', data)
            if (res.status === 200) {
              this.$router.push({ name: 'seoPageMetaList' })
            }
          } catch (err) {
            this.showErrorFromResponse(err)
          }

          this.loading = false
        } else {
          this.snackbar = true
          document.getElementById('fcreate').scrollIntoView({
            behavior: 'smooth',
          })

          setTimeout(() => {
            this.snackbar = false
          }, 3000)
        }
      },
    },
  }
</script>
